<div class="bk-login__container">
	<div class="bk-login">
		<div class="bk-login__welcome-box">
			<h4>Password Reset Confirmation</h4>
			<p>Your password has been reset. Please <a routerLink="/login">click here to login.</a></p>
		</div>
	</div>
</div>
